// eslint-disable-next-line no-restricted-imports
import { Button as ButtonChakra, ButtonProps as ButtonPropsChakra, forwardRef } from "@chakra-ui/react";
import { ButtonSpinner } from "@chakra-ui/react";

// Dev-Note: custom button wrapper is needed to override Chakra-UI mechanism which disables button when isLoading is true
// for more info look at comments here https://wikifolio.atlassian.net/browse/WIKI-31289
export const Button = forwardRef(({ ...buttonProps }: ButtonPropsChakra, ref) => {
    const { isLoading, children, ...restButtonProps } = buttonProps;

    return (
        <ButtonChakra ref={ref} {...restButtonProps}>
            {isLoading ? <ButtonSpinner placement="start" /> : <>{children}</>}
        </ButtonChakra>
    );
});
